module.exports = __webpack_public_path__ + "static/eventum-52666ebd2aa25262d3e72b940f51ccb6.png";